<template>
	<div class="text-gray-500 text-bold text-center font-bold">404 | PAGE NOT FOUND</div>
</template>

<script setup lang="ts"></script>

<style scoped></style>
